/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, April 21st 2022, 8:38:32 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { OSFormInputProps, ListButtonAutoCompleteFormInput } from "ui-widgets/forms";
import { STAFF_USER_TYPES, STAFF_USER_TYPES_DESCRIPTIONS } from "lib/schemas";
import Typography from "@mui/material/Typography";

export const WorkerTypeDropDownInput = <T,>(props: OSFormInputProps<T>) => {
  return (
    <ListButtonAutoCompleteFormInput<T>
      schema_field_key={props.schema_field_key}
      label={props.label}
      helperText={props.helperText}
      options={Object.keys(STAFF_USER_TYPES)}
      getPrimaryOptionLabel={(option) => STAFF_USER_TYPES[option]}
      getSecondaryOptionLabel={(option) => (
        <Typography variant="subtitle2" className="os-invite-worker-label">
          {STAFF_USER_TYPES_DESCRIPTIONS[option]}
        </Typography>
      )}
      fullWidth
      disableClearable
    />
  );
};
